import json from './resume.json';
export const resume = json;
